import React from 'react';

import BonusCash from '../BonusCash/BonusCash';
import Error from '../Error/Error';
import MaxPayout from '../MaxPayout/MaxPayout';
import { PriceChangeAlert } from '../PriceChangeAlert/PriceChangeAlert';
import UpdateCurrency from '../UpdateCurrency/UpdateCurrency';

import styles from './Messages.scss';

const Messages: React.FC = () => (
  <ul className={styles.messages}>
    <UpdateCurrency />
    <BonusCash />
    <MaxPayout />
    <Error />
    <PriceChangeAlert />
  </ul>
);

export default Messages;
